import React from 'react';
import { gettext } from '@eventbrite/i18n';
import { InfoCards } from './InfoCards';
import { FAQSection as PricingFAQ } from '../containers/pricingFAQ';
import { Typography, Button } from '@eventbrite/marmalade';
import { CompetitorComparisionBlock } from './NewPricingAndPackaging/CompetitorComparisionBlock';
import { RisingDemandBlock } from './NewPricingAndPackaging/RisingDemandBlock';
import { FeeBreakdown } from './FeeBreakdown';
import { SalesBlock } from './SalesBlock';
import { TestimonialBlock } from './TestimonialBlock';
import { PricingAndPackagingHeader } from './PricingAndPackagingHeader';

import styles from './PricingAndPackagingNew.module.scss';

export const PricingAndPackagingNew = () => {
    return (
        <div className={styles.pricing_and_packaging_page_new}>
            <PricingAndPackagingHeader />
            <InfoCards />
            <RisingDemandBlock />
            <FeeBreakdown />
            <SalesBlock />
            <TestimonialBlock />
            <CompetitorComparisionBlock />
            <PricingFAQ />
            <Button
                onClick={() => {
                    window.location.href =
                        '/signin/signup/?referrer=%2Fmanage%2Fevents%2Fcreate%2F';
                }}
                variant="secondary"
                size="responsive"
                className={styles.getStartedBtn}
            >
                <Typography
                    variant="body-md-bold"
                    className={styles.getStartedBtnText}
                >
                    {gettext('Get started for free')}
                </Typography>
            </Button>
        </div>
    );
};

export default PricingAndPackagingNew;
